export const sanitizeOptions = {
  allowedAttributes: {
    a: ['href', 'name', 'target', 'rel'],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
    strong: ['title', 'data-user-id', 'class', 'contenteditable']
  },
  allowedTags: ['div', 'p', 'a', 'b', 'br', 'i', 's', 'em', 'small', 'span', 'strong']
}
